import React, { useContext, useEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import { each, isNil } from 'lodash';
import { settings } from './config';
import { useApi } from './ApiContext';

export const EventPreviewContext = React.createContext();

export const useEventPreview = () => useContext(EventPreviewContext);

const getIsAvailable = (params, roles, sid, hasAuthInitialized) => {

    // cannot make an assessment without event params
    if (isNil(params)){
        return true;
    }

    if (params.IsPublished){
        return true;
    }

    // CRITICAL: Don't evaluate admin access until auth is fully initialized
    // This prevents race condition where eventParams loads before auth state
    if (!hasAuthInitialized) {
        return true; // Wait for auth to initialize
    }

    // ✅ NEW: Also wait if roles haven't loaded yet (still empty from initial state)
    // This prevents false negatives when eventParams loads before auth token is decoded
    if (roles.length === 0 && localStorage.getItem('login')) {
        return true;  // Token exists but hasn't been decoded yet - wait
    }

    if (roles.includes("GlobalAdmin")){
        return true;
    }

    if (isNil(sid) || isNil(params.AccountKey)){
        return false;
    }

    if (roles.includes("Admin") && sid === params.AccountKey){
        return true;
    }

    return false;
}

export const EventPreviewProvider = ({ children }) => {

    const { roles, sid } = useAuth();

    const { alertError } = useApi();

    const [eventParams, setEventParams] = useState(null);
    const [hasAuthInitialized, setHasAuthInitialized] = useState(false);
    
    // Mark auth as initialized after first render (localStorage has been read)
    useEffect(() => {
        setHasAuthInitialized(true);
    }, []);
    
    useEffect(()=>{

        if (settings.isDebug){
            let roleList = "";
            each(roles, function(role){
                roleList += role + ",";
            });

            console.log(`EVENT PREVIEW ASSESSMENT\nsid ${sid}\nroles ${roleList}\nIsPublished ${eventParams && eventParams.IsPublished}\nAccountKey ${eventParams && eventParams.AccountKey}\nhasAuthInitialized ${hasAuthInitialized}`);
        }

        if (!getIsAvailable(eventParams, roles, sid, hasAuthInitialized)){

            window.location = '/errors/404';
        }
    },[eventParams, roles, sid, hasAuthInitialized, alertError]);

    return (
        <EventPreviewContext.Provider
            value={{
                setEventParams,
                isAvailable: getIsAvailable(eventParams, roles, sid, hasAuthInitialized)
            }}
        >
            {children}
        </EventPreviewContext.Provider>
    );
};